
const create = function () {
  return {
    content_type: "muji"
  };
};
const descriptor = {};

const fields = {
  default: [
    {
      key: "id",
      label: "编号",
      sortable: true,
      button: {
        type: "text"
      },
      thStyle: {
        width: "60px"
      }
    },
    {
      key: "SalesId",
      label: "平台采购订单编号",
      sortable: true
    },
    {
      key: "dataAreaId",
      label: "销售公司",
      sortable: true,
      thStyle: {
        width: "5rem"
      }
    },
    {
      key: "CompanyName",
      label: "销售公司名称",
      sortable: true,
      thStyle: { width: "8rem" },
      width: "8rem",
      type: "short"
    },
    {
      key: "SEI_BigCustomerNumber",
      label: "TOP客户组",
      sortable: true,
      thStyle: {
        width: "10rem"
      },
      type: "short"
    },
    {
      key: "CustAccount",
      label: "客户帐户",
      sortable: true
    },
    {
      key: "SalesName",
      label: "客户名称",
      sortable: true,
      thStyle: {
        width: "15rem"
      }
    },
    {
      key: "InvoiceAccount",
      label: "发票帐户",
      sortable: true
    },
    {
      key: "DeliveryDate",
      label: "装运日期",
      sortable: true,
      type: "date"
    },
    {
      key: "OrderAmount",
      label: "订单金额",
      sortable: true,
      type: "number",
      _precise: 2,
      thStyle: {
        width: "5rem"
      }
    },
    {
      key: "OrderAmountWOTax",
      label: "本币不含税金额",
      sortable: true,
      type: "number",
      _precise: 2,
      thStyle: {
        width: "8rem"
      }
    },
    {
      key: "CurrencyCode",
      label: "币种",
      sortable: true
    },
    {
      key: "ExchRate",
      label: "汇率",
      sortable: true,
      type: "number",
      _precise: 4
    },
    {
      key: "TaxGroup",
      label: "销售税组",
      sortable: true
    },
    {
      key: "SalesPoolId",
      label: "池",
      sortable: true
    },
    {
      key: "InclTax",
      label: "价格包括销售税",
      sortable: true
    },

    {
      key: "TEC_Remark",
      label: "备注",
      sortable: true
    },
    {
      key: "TEC_FinalCustAccount",
      label: "最终客户",
      sortable: true
    }
  ],
  detail_fields: [
    {
      key: "LineNum",
      label: "行号",
      sortable: true,
      width: "40px"
    },
    {
      key: "ItemId",
      label: "物料编号",
      sortable: true
    },
    {
      key: "NameAlias",
      label: "物料名称",
      sortable: true,
      type: "short",
      thStyle: {
        width: "12rem"
      }
    },
    {
      key: "VariantName",
      label: "变型名称",
      sortable: true,
      type: "short",
      thStyle: {
        width: "8rem"
      }
    },
    {
      key: "SalesQty",
      label: "数量",
      sortable: true,
      type: "number"
    },
    {
      key: "SalesPrice",
      label: "价格",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "DiscPrice",
      label: "协议价格",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "CurrencyCode",
      label: "币种",
      sortable: true
    },
    {
      key: "SalesPriceWOTax",
      label: "本币净单价",
      sortable: true,
      type: "number",
      _precise: 6
    },
    {
      key: "ConfirmedDlv",
      label: "装运日期",
      sortable: true,
      type: "date"
    },
    {
      key: "SEI_OrderDateCust",
      label: "客户订单日期",
      sortable: true,
      type: "date"
    },
    {
      key: "SEI_ShippingDateCust",
      label: "客户交期",
      sortable: true,
      type: "date"
    },
    {
      key: "TEC_CommonRemark",
      label: "通用备注",
      sortable: true,
      type: "textarea"
    },
    {
      key: "TEC_OtherInfo",
      label: "其他信息",
      sortable: true,
      type: "textarea"
    },
    {
      key: "TEC_CustSalesID",
      label: "客户订单号",
      sortable: true,
      type: "textarea"
    },

    {
      key: "SEI_DimensionFG",
      label: "FG维度",
      sortable: true
    }
  ]
};

const methods = {};
export { fields, methods };

